module.exports = __webpack_public_path__ + "assets/img/The-Onset-Website-w960.a6317cb1.jpg";